import { createContext, useState, useMemo, useContext, useEffect, useCallback } from 'react';
import Cookies from 'universal-cookie';
import { useGeneral } from '../../Context/GeneralContext';

const LoginContext = createContext();

export function LoginProvider(props) {
    const { infoUser, setInfoUser } = useGeneral();
    const [usuario, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [errorU, setErrorU] = useState(false);
    const [errorC, setErrorC] = useState(false);
    const [isConfig, setIsConfig] = useState(false);
    const [configView, setConfigView] = useState(false);
    const [errorV, setErrorV] = useState(false);
    const [tokenL, setTokenL] = useState('');
    const [selectLine, setSelectLine] = useState('');
    const [selectCelda, setSelectCelda] = useState('');
    const [filterCell, setFilterCell] = useState([]);
    const [values, setValues] = useState({
        password: '',
        showPassword: false,
    });
    const [lines, setLines] = useState([]);
    const [celdas, setCeldas] = useState([]);
    const [openA, setOpenA] = useState(false);
    const [openB, setOpenB] = useState(false);
    const [openC, setOpenC] = useState(false);
    const [openW, setOpenW] = useState(false);
    const [loading, setLoading] = useState(false);

    const [card1, setCard1] = useState(false);
    const [login, setLogin] = useState(false);

    const [auto, setAuto] = useState(false);
    const [count, setCount] = useState(false);
    const [andon, setAndon] = useState(false);

    useEffect(() => {

        if (!tokenL.token) return;
        const getLines = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/lineas`, {
                    method: 'GET',
                    headers: {
                        authorization: `Bearer ${tokenL.token}`,
                        Accept: 'application/json',
                    },
                });
    
                if (!response.ok) {
                    console.error(`Error: ${response.status} ${response.statusText}`);
                    return;
                }
    
                const contentType = response.headers.get('content-type');
                if (contentType && contentType.includes('application/json')) {
                    const lines = await response.json();
                    setLines(lines);
                } else {
                    console.error('Response is not JSON');
                }
            } catch (error) {
                console.error('Fetch error:', error);
            }
        };
    
        getLines();
    }, [tokenL.token]);
    
    

    const filtrarCeldas = useCallback((cells) => {
        const celdasF = [];
    
        if (Array.isArray(cells)) {
            cells.forEach((celda) => {
                if (celda.linea === parseInt(selectLine)) {
                    celdasF.push(celda);
                }
            });
        }  

        setFilterCell(celdasF);
    }, [selectLine]);

    useEffect(() => {
        if (!tokenL?.token) return;
    
        const getCeldas = async () => {
            try {
                const data = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/celdas`, {
                    method: 'GET',
                    headers: {
                        authorization: `Bearer ${tokenL.token}`,
                        Accept: 'application/json',
                    },
                });
    
                if (data.status === 200) {
                    const celdas = await data.json();
                    setCeldas(celdas);
                    filtrarCeldas(celdas);
                } else {
                    console.error(`Error ${data.status}: no autorizado`);
                }
            } catch (err) {
                console.error('Error en getCeldas:', err);
            }
        };
    
        getCeldas();
    }, [tokenL.token, filtrarCeldas]);
    
    const LoginUser = useCallback(async (credentials) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/usuarios/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(credentials),
            });
    
            if (!response.ok) return false;
    
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error during login:', error);
            return false;
        }
    }, []);
    

    const handleClickShowPassword = useCallback(() => {
        setValues((prev) => ({
            ...prev,
            showPassword: !prev.showPassword,
        }));
    }, []);
    
    const handleUserName = useCallback((e) => {
        setUserName(e);
        setErrorU(false);
        setErrorV(false);
    },[]);

    const handleChangeLine = useCallback((e) => {
        e.preventDefault();

        setSelectLine(e.target.value);
    },[]);

    const handleChangeCelda = useCallback((e) => {
        e.preventDefault();

        setSelectCelda(e.target.value);
    },[]);

    const handleChange = useCallback(
        (prop) => (event) => {
            setValues((prevValues) => ({
                ...prevValues,
                [prop]: event.target.value,
            }));
        },
        []
    );

    const handlePassChange = useCallback((e) => {
        e.preventDefault();
        setErrorC(false);
        setErrorV(false);
        setPassword(e.target.value);
        handleChange('password')(e);
    },[handleChange]);

    const getUsuario = useCallback(async (usuario, token) => {
        const cookie = new Cookies();
        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/usuarios/GetUsuario?username=${usuario}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${token}`,
                    Accept: 'application/json',
                },
            }
        );
        const info = await data.json();
        if (data.status !== 404) {
            const current = new Date();
            const nextYear = new Date();
            nextYear.setFullYear(current.getFullYear() + 1);
            setInfoUser(info);
            cookie.set('nombre', `${info.nombre  } ${  info.apellido}`, {
                path: '/',
                expires: nextYear,
            });
            cookie.set('usuario', usuario, { path: '/', expires: nextYear });
            return info;
        } else {
            setInfoUser([]);
            return null;
        }
    },[setInfoUser]);

    useEffect(() => {
        if (tokenL) {
            setLines([]);
            setCeldas([]);
        }
    }, [setCeldas, setLines, tokenL]);

    useEffect(() => {
        const cookie = new Cookies();
        if (
            cookie.get('auto') &&
            cookie.get('login') &&
            cookie.get('card') &&
            cookie.get('linea') &&
            cookie.get('count') &&
            cookie.get('celda')
        ) {
            setCard1(cookie.get('card') === 'true');
            setLogin(cookie.get('login') === 'true');
            setAuto(cookie.get('auto') === 'true');
            setSelectLine(cookie.get('linea'));
            setCount(cookie.get('count') === 'true');
            setAndon(cookie.get('andon') === 'true');
            setSelectCelda(cookie.get('celda'));
        }
    }, []);

    useEffect(() => {
        filtrarCeldas(celdas);
    }, [celdas, filtrarCeldas, selectLine]);

    const loginValues = useMemo(() => {
        return {
            handleUserName,
            handleChangeLine,
            handleChangeCelda,
            handlePassChange,
            tokenL,
            configView,
            isConfig,
            errorU,
            errorC,
            errorV,
            setIsConfig,
            selectLine,
            selectCelda,
            setSelectCelda,
            handleClickShowPassword,
            values,
            lines,
            celdas,
            usuario,
            password,
            setErrorU,
            setErrorC,
            LoginUser,
            setConfigView,
            setInfoUser,
            setTokenL,
            setErrorV,
            getUsuario,
            infoUser,
            setSelectLine,
            openA,
            setOpenA,
            openB,
            setOpenB,
            openC,
            setOpenC,
            openW,
            setOpenW,
            filterCell,
            setFilterCell,
            filtrarCeldas,
            card1,
            setCard1,
            login,
            setLogin,
            auto,
            setAuto,
            count,
            setCount,
            andon,
            setAndon,
            loading,
            setLoading,
        };
    }, [
        handleUserName,
        handleChangeLine,
        handleChangeCelda,
        handlePassChange,
        tokenL,
        configView,
        isConfig,
        errorU,
        errorC,
        errorV,
        setIsConfig,
        selectLine,
        selectCelda,
        setSelectCelda,
        handleClickShowPassword,
        values,
        lines,
        celdas,
        usuario,
        password,
        setErrorU,
        setErrorC,
        LoginUser,
        setConfigView,
        setInfoUser,
        setTokenL,
        setErrorV,
        getUsuario,
        infoUser,
        setSelectLine,
        openA,
        setOpenA,
        openB,
        setOpenB,
        openC,
        setOpenC,
        openW,
        setOpenW,
        filterCell,
        setFilterCell,
        filtrarCeldas,
        card1,
        setCard1,
        login,
        setLogin,
        auto,
        setAuto,
        count,
        setCount,
        andon,
        setAndon,
        loading,
        setLoading,
    ]);

    return <LoginContext.Provider value={loginValues} {...props} />;
}

export function useLogin() {
    const context = useContext(LoginContext);
    if (!context) {
        throw new Error('useLogin debe estar dentro del proveedor LoginContext');
    }
    return context;
}
